import { render } from "./ModalMatchInformation.vue?vue&type=template&id=26b050c3&scoped=true"
import script from "./ModalMatchInformation.vue?vue&type=script&lang=js"
export * from "./ModalMatchInformation.vue?vue&type=script&lang=js"

import "./ModalMatchInformation.vue?vue&type=style&index=0&id=26b050c3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26b050c3"

export default script